'use client';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconCloseCircle } from '@blocks-react/components/Icons/CloseCircle';
import { useFormContext } from 'react-hook-form';

interface DealerLocatorFiltersClearServiceOfferingsButtonProps {
  children: string;
}

export const DealerLocatorFiltersClearServiceOfferingsButton = ({
  children
}: DealerLocatorFiltersClearServiceOfferingsButtonProps) => {
  const { reset } = useFormContext();
  const clearFilters = () => {
    reset();
  };

  return (
    <CatButton className="ps-0" onClick={clearFilters} variant="ghost">
      {children}
      <CatIconCloseCircle slot="after" />
    </CatButton>
  );
};
